import '../../../stylesheets/nav/profile-popover.css'
import SubscriptionSectionHeader    from "./SubscriptionSectionHeader.js"
import SubscriptionSectionOne       from "./subscription-modal/SubscriptionSectionOne.js"
import SubscriptionSectionTwo       from "./subscription-modal/SubscriptionSectionTwo.js"

/*
 * SubscriptionModal — static HTML + CSS shell.
 * Wrapping logic (open/close state, prop-driven content, etc.) handled by parent.
 * Placeholder text below should be swapped for prop bindings (subscription.planName,
 * paymentMethod.brand, .last4, .wallet, etc.) when wiring up.
 */
const SubscriptionModal = ({ user, subscription, paymentMethod, toggleClose }) => {
    // Gate Pattern: at LCA (lowest common ancestor) since both child nodes consume this resource)
    // FUTURE IMPROVEMENTS: some spinner while this is null (i.e. null = loading ideally, since initial state of these variables while we are fetching resources to hydrate their state with is null)
    // and if null doesnt resolve to an object via our null object pattern framework in 10 seconds - i.e. likely some network or server error out of our control
    // display the below text in this section
    if ( subscription === null || paymentMethod === null ) {
        return (
            <div className="modal-content-fallback-text"> Our apologies, cannot display subscription details at this time. Try to refresh! </div>
        )
    }    

    return (
        <div className="subscription-modal-overlay">
            <div className="subscription-modal">

                <SubscriptionSectionHeader toggleClose={toggleClose}                                       />
                <div className="subscription-modal-divider">                                           </div>       
                <SubscriptionSectionOne subscription={subscription} paymentMethod={paymentMethod}          />                                                             
                <div className="subscription-modal-divider">                                           </div>
                <SubscriptionSectionTwo user={user} subscription={subscription}                            />
                
            </div>
        </div>
    )
}

export default SubscriptionModal